import { shouldRun } from "./shouldRun";
import { vRequired } from "./vRequired";
import { vPattern } from "./vPattern";
import { vLength } from "./vLength";
import { vCustom } from "./vCustom";


const isEmptyHtml = (val) => {
  if (!val) return true;
  const str = String(val).trim();
  return (
    str === "" || str === "<p></p>" || str === "<br>" || str === "<p><br></p>"
  );
};

export const validate = async ({
  val,
  rules = [],
  trigger = "onChange",
  skipRequired = false,
  compOnChange = false,
}) => {
  const empty = isEmptyHtml(val);

  for (const r of rules) {
    if (!shouldRun(r, trigger, compOnChange)) continue;

    const err =
      vRequired(r, val, empty, trigger, skipRequired) ||
      (await vCustom(r, val)) ||
      vPattern(r, val) ||
      vLength(r, val);

    if (err) return err;
  }

  return null;
};
